import { useMemo } from 'react';
import { useTranslation } from '@shared/core';
import type { Maybe } from '@graphql/generated';

export const useTransformRatingToCategory = (rating?: Maybe<number>) => {
  const { tq } = useTranslation('accommodationsShared');
  const ratingCategory = useMemo(() => {
    const normalizedRating = rating ?? 0;
    switch (true) {
      case normalizedRating >= 9:
        return tq`Wonderful`;
      case normalizedRating >= 8.5:
        return tq`Fabulous`;
      case normalizedRating >= 8:
        return tq`Very Good`;
      case normalizedRating >= 7:
        return tq`Good`;
      case normalizedRating >= 6:
        return tq`Pleasant`;
      default:
        return '';
    }
  }, [rating, tq]);

  return ratingCategory;
};
